import React from "react";
import { Container } from "react-bootstrap";
import ReactPlayer from "react-player";
import "../../src/styles/LandingPage.scss";
import landingPageBg from "../assets/images/landingPageBg.jpeg";
const LandingPage = () => {
  return (
    <Container fluid className="p-0 landing-page-container">
      <span>
        <img src={landingPageBg} alt="" className="landing-page-bg" />
        {/* <ReactPlayer
          url="https://www.youtube.com/watch?v=lYDbn1rY5Mw"
          width="100%"
          height="100%"
          playing={true}
          muted={true}
          loop={true}
          playsinline={true}
          className="landing-page-bg"
        /> */}
      </span>
    </Container>
  );
};

export default LandingPage;
